import { EmptyMessage } from '../../components/EmptyMessage';
import { ErrorText } from '../../components/ErrorText';
import { GolfTeeTimeCard } from '../../components/GolfTeeTimeCard';
import { PageHeading } from '../../components/PageHeading';
import {
  ErrorRow,
  FilterNote,
  Grid,
  Intro,
  MetaText,
  ScrollContainer,
} from './GolfTeeTimesContent.styles';
import type { GolfTeeTimesContentProps } from './GolfTeeTimesContent.types';

export function GolfTeeTimesContent({
  metaText,
  filterNote,
  teeTimes,
  selectedTeeTime,
  onTeeTimeSelect,
  teeTimeError,
  labels,
}: GolfTeeTimesContentProps) {
  const title = labels?.title ?? 'Golf.';
  const subtitle = labels?.subtitle ?? 'Select your tee time.';
  const groupLabel = labels?.teeTimesGroupLabel ?? 'Tee times';
  const noTeeTimesText =
    labels?.noTeeTimesText ?? 'No tee times match your search. Change your date or party size.';

  return (
    <ScrollContainer>
      <Intro>
        <PageHeading title={title} subtitle={subtitle} centered flush />
        {metaText && <MetaText>{metaText}</MetaText>}
        {filterNote && <FilterNote>{filterNote}</FilterNote>}
      </Intro>

      {teeTimes.length > 0 ? (
        <Grid role="listbox" aria-label={groupLabel} aria-invalid={!!teeTimeError || undefined}>
          {teeTimes.map((teeTime) => (
            <GolfTeeTimeCard
              key={teeTime.value}
              time={teeTime.time}
              spotsText={teeTime.spotsText}
              priceText={teeTime.priceText}
              selected={teeTime.value === selectedTeeTime}
              disabled={teeTime.disabled}
              ariaLabel={teeTime.ariaLabel}
              onSelect={() => onTeeTimeSelect(teeTime.value)}
            />
          ))}
        </Grid>
      ) : (
        <EmptyMessage role="status">{noTeeTimesText}</EmptyMessage>
      )}

      {teeTimeError && (
        <ErrorRow>
          <ErrorText>{teeTimeError}</ErrorText>
        </ErrorRow>
      )}
    </ScrollContainer>
  );
}
